import type { WorktreeBaseBranches } from '@buildautomaton/types';
import type { ApiToBridgePromptMessage } from '../../../../types/api-to-bridge-messages.js';

export function parseWorktreeBaseBranches(msg: ApiToBridgePromptMessage): WorktreeBaseBranches | undefined {
  const raw = msg.worktreeBaseBranches;
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return undefined;
  const out: WorktreeBaseBranches = {};
  for (const [k, v] of Object.entries(raw)) {
    if (typeof k !== 'string' || typeof v !== 'string') continue;
    const rel = k.trim();
    const branch = v.trim();
    if (rel && branch) out[rel] = branch;
  }
  return Object.keys(out).length > 0 ? out : undefined;
}
